import React, { useEffect, useRef, useState } from 'react';
import './PortfolioPlChart.scss';
import { PortfolioPlPerformanceChart } from 'widgets/portfolioPl/chart/performance/PortfolioPlPerformanceChart';
import { PortfolioPlLeavesChart } from 'widgets/portfolioPl/chart/leaves/PortfolioPlLeavesChart';
import { PortfolioPlData } from 'widgets/portfolioPl/portfolioPlData';
import { PortfolioPlWidgetConfigState } from 'widgets/portfolioPl/store/config/PortfolioPlWidgetConfigState';
import {
    PortfolioPlDimensions,
    usePortfolioPlDimensions,
} from 'widgets/portfolioPl/dimensions';
import { usePortfolioPlConfigSlice } from 'widgets/portfolioPl/store/config/configSlice';

export interface PortfolioPlChartProps {
    width: number;
    data: PortfolioPlData;
}

export interface PortfolioPlSubChartProps {
    width: number;
    dimensions: PortfolioPlDimensions;
    data: PortfolioPlData;
    config: PortfolioPlWidgetConfigState;
    containerLeft: number;
}

export function PortfolioPlChart(props: PortfolioPlChartProps) {
    const { data, width } = props;
    const { config } = usePortfolioPlConfigSlice();

    const divRef = useRef<HTMLDivElement>(null);
    const [left, setLeft] = useState(0);
    useEffect(() => {
        if (!divRef.current) {
            return;
        }
        setLeft(divRef.current.getBoundingClientRect().left);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width, divRef.current]);

    const dimensions = usePortfolioPlDimensions();
    const { leavesHidden } = config;

    const childProps: PortfolioPlSubChartProps = {
        width,
        dimensions,
        data,
        config,
        containerLeft: left,
    };

    return (
        <div
            className="PortfolioPlChart"
            ref={divRef}
            style={{
                height: dimensions.chartsHeight + 'px',
                width: width + 'px',
            }}
        >
            <PortfolioPlPerformanceChart {...childProps} />
            {!leavesHidden && <PortfolioPlLeavesChart {...childProps} />};
        </div>
    );
}
